import CobraSpinner from '../shared/CobraSpinner';
import React, { useState, useEffect } from 'react';
import {
    Box,
    Button,
    Flex,
    Heading,
    Text,
    VStack,
    HStack,
    IconButton,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalCloseButton,
    ModalBody,
    ModalFooter,
    FormControl,
    FormLabel,
    Input,
    Textarea,
    useDisclosure,
    useColorModeValue,
    
    useToast,
    Badge,
    Divider,
    Card,
    CardBody,
    CardHeader,
    Progress,
    Tooltip,
    Container,
    useBreakpointValue,
    Stack,
    Collapse,
    ScaleFade,
    SlideFade,
    Image,
    SimpleGrid,
    Avatar,
    Center,
    Checkbox,
    CheckboxGroup,
    Menu,
    MenuButton,
    MenuList,
    MenuItem,
    Portal} from '@chakra-ui/react';
import { FaTrash, FaVideo, FaPaperclip, FaArrowUp, FaArrowDown, FaPlay, FaClock, FaEye, FaChevronRight, FaGraduationCap, FaBookOpen } from 'react-icons/fa';
import { FiLock, FiUnlock, FiMessageSquare, FiChevronDown } from "react-icons/fi";
import { MdCloudDone, MdCheckCircle } from 'react-icons/md';
import { AddIcon, DeleteIcon, HamburgerIcon } from '@chakra-ui/icons';
import axiosInstance from '../services/axiosInstance';
import { useParams } from 'react-router-dom';
import { deleteVideo, fetchCourseById, toggleChaptire, waitForVideoConversion } from '../services/courseService';
import VideoPlayer from '../shared/videoplayer';
import NewChapterToCourse from '../shared/newchapitreCreation';
import AddPartieForm from '../shared/AddPartieForm';
import { urlvideo } from '../services/urls';

const CourseDetailsContent = () => {
    const { id } = useParams();
    const [courseData, setCourseData] = useState(null);
    const [selectedVideo, setSelectedVideo] = useState(null);
    const [videoUploadModalOpen, setVideoUploadModalOpen] = useState(false);
    const [uploadSource, setUploadSource] = useState('file'); // 'file' | 'recording' | 'liveUrl'
    const [recordings, setRecordings] = useState([]);
    const [selectedRecording, setSelectedRecording] = useState(null);
    const [recordingsLoading, setRecordingsLoading] = useState(false);
    const [recordingsSearch, setRecordingsSearch] = useState('');
    const [onlyMatchingMatiere, setOnlyMatchingMatiere] = useState(true);
    const [liveSessionUrl, setLiveSessionUrl] = useState('');
    const [selectedChapterIndex, setSelectedChapterIndex] = useState(null);
    const [selectedPartieIndex, setSelectedPartieIndex] = useState(null);
    const [ChaterID, setChaterID] = useState(null);
    const [newVideo, setNewVideo] = useState({
        name: '',
        description: '',
        duree: '',
        file: null,
    });
    const [isCalculatingDuration, setIsCalculatingDuration] = useState(false);
    const [uploadAnimation, setUploadAnimation] = useState(false);
    const [uploadProgress, setUploadProgress] = useState(0);
    const [attachments, setAttachments] = useState([]);
    const [AttchmentName, setAttchmentName] = useState('');
    const [attachmentModalOpen, setAttachmentModalOpen] = useState(false);
    const { isOpen, onOpen, onClose } = useDisclosure();
    const [isAddNewPartieOpen, setisAddNewPartieOpen] = useState(false);
    const [expandedChapters, setExpandedChapters] = useState(new Set([0]));
    const [expandedParties, setExpandedParties] = useState(new Set());
    const toast = useToast();

    // Homework replies state
    const [allHomeworkReplies, setAllHomeworkReplies] = useState([]);
    const [isLoadingHomework, setIsLoadingHomework] = useState(false);
    const [isSmsModalOpen, setIsSmsModalOpen] = useState(false);
    const [isSendingSms, setIsSendingSms] = useState(false);
    const [customMessage, setCustomMessage] = useState('');
    const [smsType, setSmsType] = useState('absent'); // 'absent' or 'present'

    const [isBulkSmsModalOpen, setIsBulkSmsModalOpen] = useState(false);
    const [selectedVideosForSms, setSelectedVideosForSms] = useState([]);
    const [bulkSmsMessage, setBulkSmsMessage] = useState('');
    const [isSendingBulkSms, setIsSendingBulkSms] = useState(false);
    const [bulkSmsTarget, setBulkSmsTarget] = useState('parents');

    // Remarks state
    const [editingRemarkId, setEditingRemarkId] = useState(null);
    const [remarkText, setRemarkText] = useState('');
    const [isSavingRemark, setIsSavingRemark] = useState(false);

    const handleSaveRemark = async (replyId) => {
        setIsSavingRemark(true);
        try {
            await axiosInstance.put(`/video-homework/reply/${replyId}/remarque`, {
                remarque: remarkText
            });
            setAllHomeworkReplies(prev => prev.map(r => r._id === replyId ? { ...r, remarque: remarkText } : r));
            setEditingRemarkId(null);
            setRemarkText('');
            toast({ title: 'تم حفظ الملاحظة بنجاح', status: 'success', duration: 3000, position: 'top-left' });
        } catch (err) {
            toast({ title: 'خطأ', description: 'فشل حفظ الملاحظة', status: 'error', duration: 3000, position: 'top-left' });
        } finally {
            setIsSavingRemark(false);
        }
    };

    const fetchHomeworkReplies = async (video) => {
        if (!video?._id || !courseData?._id) return;
        setIsLoadingHomework(true);
        try {
            const res = await axiosInstance.get(`/video-homework/${video._id}/replies`, {
                params: { courseId: courseData._id }
            });
            setAllHomeworkReplies(res.data.data || []);
        } catch (err) {
            console.error('Error fetching homework replies:', err);
        } finally {
            setIsLoadingHomework(false);
        }
    };

    const handleSendSms = async (sendTo) => {
        if (!selectedVideo || !courseData) return;
        setIsSendingSms(true);
        try {
            const endpoint = smsType === 'present' 
                ? '/video-homework/send-present-sms' 
                : '/video-homework/send-sms';
            
            const res = await axiosInstance.post(endpoint, {
                videoId: selectedVideo._id,
                courseId: courseData._id,
                videoName: selectedVideo.nomvideo || 'فيديو',
                sendTo,
                customMessage,
            });
            toast({
                title: res.data.message,
                status: res.data.success ? 'success' : 'warning',
                duration: 4000,
                isClosable: true,
                position: 'top-left',
            });
            setIsSmsModalOpen(false);
        } catch (err) {
            toast({
                title: 'خطأ في الإرسال',
                description: err.response?.data?.message || 'فشل في إرسال الرسائل',
                status: 'error',
                duration: 4000,
                isClosable: true,
                position: 'top-left',
            });
        } finally {
            setIsSendingSms(false);
        }
    };

    const openSmsModal = (type) => {
        setSmsType(type);
        if (type === 'absent') {
            setCustomMessage(`عزيزي الطالب {studentName}، يرجى إرسال واجبك المنزلي الخاص بالفيديو: {videoName}. شكراً. - منصة كوبرا`);
        } else {
            setCustomMessage(`شكراً لك يا {studentName} على إرسال واجبك المنزلي الخاص بالفيديو: {videoName}. - منصة كوبرا`);
        }
        setIsSmsModalOpen(true);
    };

    const openBulkSmsModal = () => {
        // Collect all videos across all chapters and parts
        const allVideos = [];
        if (courseData && courseData.chapitres) {
            courseData.chapitres.forEach(chapter => {
                if (chapter.parties) {
                    chapter.parties.forEach(part => {
                        if (part.videos) {
                            part.videos.forEach(video => {
                                allVideos.push(video);
                            });
                        }
                    });
                }
            });
        }
        // Pre-select all by default
        setSelectedVideosForSms([]);
        setBulkSmsMessage('');
        setIsBulkSmsModalOpen(true);
    };

    const handleBulkSmsSubmit = async () => {
        if (!courseData || selectedVideosForSms.length === 0) {
            toast({ title: 'خطأ', description: 'يرجى تحديد فيديو واحد على الأقل', status: 'error', duration: 4000, isClosable: true });
            return;
        }
        setIsSendingBulkSms(true);
        try {
            // Find video objects
            const videosData = [];
            courseData.chapitres.forEach(ch => {
                ch.parties.forEach(p => {
                    p.videos.forEach(v => {
                        if (selectedVideosForSms.includes(v._id)) {
                            videosData.push({ videoId: v._id, videoName: v.title || v.nomvideo || 'فيديو' });
                        }
                    });
                });
            });

            const res = await axiosInstance.post('/video-homework/bulk-send-sms', {
                courseId: courseData._id,
                videos: videosData,
                sendTo: bulkSmsTarget,
                customMessage: bulkSmsMessage
            });
            toast({ title: 'النتيجة', description: res.data.message, status: res.data.success ? 'success' : 'warning', duration: 5000, isClosable: true, position: 'top-left' });
            if (res.data.success) {
                setIsBulkSmsModalOpen(false);
            }
        } catch (error) {
            toast({ title: 'خطأ', description: error.response?.data?.message || 'فشل في الإرسال', status: 'error', duration: 4000, isClosable: true, position: 'top-left' });
        } finally {
            setIsSendingBulkSms(false);
        }
    };

    // Responsive breakpoints
    const isMobile = useBreakpointValue({ base: true, md: false });
    const sidebarWidth = useBreakpointValue({ base: "0", md: "200px", lg: "250px" });
    const containerPadding = useBreakpointValue({ base: 4, md: 6, lg: 8 });
    const cardSpacing = useBreakpointValue({ base: 4, md: 6, lg: 8 });
    const headerSize = useBreakpointValue({ base: "lg", md: "xl", lg: "2xl" });
    const buttonSize = useBreakpointValue({ base: "sm", md: "md", lg: "lg" });
    const modalSize = useBreakpointValue({ base: "full", md: "xl", lg: "2xl" });

    // Professional, clean color palette
    const bgColor = useColorModeValue('gray.50', 'gray.900');
    const cardBg = useColorModeValue('white', 'gray.800');
    const sectionHeaderBg = useColorModeValue('gray.100', 'gray.700');
    const sectionHeaderHoverBg = useColorModeValue('gray.200', 'gray.600');
    const partieHeaderBg = useColorModeValue('gray.50', 'gray.800');
    const partieHeaderHoverBg = useColorModeValue('gray.100', 'gray.700');
    const borderColor = useColorModeValue('gray.200', 'gray.600');
    const textColor = useColorModeValue('gray.800', 'gray.100');
    const accentColor = useColorModeValue('blue.600', 'blue.300');
    const accentBg = useColorModeValue('blue.50', 'blue.900');
    const lockRed = useColorModeValue('red.500', 'red.400');
    const lockGreen = useColorModeValue('green.500', 'green.400');

    const fetchCourseData = async () => {
        try {
            const response = await fetchCourseById(id);
            setCourseData(response.data);
            if (response.data.chapitres?.length > 0) {
                const firstChapter = response.data.chapitres[0];
                if (firstChapter.parties?.length > 0 && firstChapter.parties[0].videos?.length > 0) {
                    setSelectedVideo(firstChapter.parties[0].videos[0]);
                }
            }
        } catch (error) {
            toast({
                title: "خطأ",
                description: "فشل تحميل بيانات الدورة",
                status: "error",
                duration: 3000,
                isClosable: true,
                position: "top-left"
            });
        }
    };

    // Function to calculate video duration
    const calculateVideoDuration = (file) => {
        return new Promise((resolve, reject) => {
            const video = document.createElement('video');
            video.preload = 'metadata';
            video.onloadedmetadata = () => {
                window.URL.revokeObjectURL(video.src);
                const duration = video.duration;
                const minutes = Math.floor(duration / 60);
                const seconds = Math.floor(duration % 60);
                const formattedDuration = `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
                resolve(formattedDuration);
            };
            video.onerror = () => {
                window.URL.revokeObjectURL(video.src);
                reject(new Error('Error loading video'));
            };
            video.src = URL.createObjectURL(file);
        });
    };

    const handleVideoFileChange = async (file) => {
        if (file) {
            setIsCalculatingDuration(true);
            try {
                const duration = await calculateVideoDuration(file);
                setNewVideo(prev => ({
                    ...prev,
                    file: file,
                    duree: duration,
                    name: prev.name || file.name.replace(/\.[^/.]+$/, "")
                }));
                toast({
                    title: "تم حساب المدة",
                    description: `مدة الفيديو: ${duration}`,
                    status: "success",
                    duration: 2000,
                    isClosable: true,
                    position: "top-left"
                });
            } catch (error) {
                setNewVideo(prev => ({
                    ...prev,
                    file: file,
                    name: prev.name || file.name.replace(/\.[^/.]+$/, "")
                }));
                toast({
                    title: "تحذير",
                    description: "لم يتم حساب مدة الفيديو تلقائياً، يرجى إدخالها يدوياً",
                    status: "warning",
                    duration: 3000,
                    isClosable: true,
                    position: "top-left"
                });
            } finally {
                setIsCalculatingDuration(false);
            }
        }
    };

    useEffect(() => {
        fetchCourseData();
    }, [id]);

    const handleVideoSelect = (video) => {
        setSelectedVideo(video);
        setCustomMessage(`عزيزي الطالب {studentName}، يرجى إرسال واجبك المنزلي الخاص بالفيديو: {videoName}. شكراً. - منصة كوبرا`);
        setAllHomeworkReplies([]);
        fetchHomeworkReplies(video);
    };

    const toggleChapter = (index) => {
        const newExpanded = new Set(expandedChapters);
        if (newExpanded.has(index)) {
            newExpanded.delete(index);
        } else {
            newExpanded.add(index);
        }
        setExpandedChapters(newExpanded);
    };

    const togglePartie = (chapterIndex, partieIndex) => {
        const key = `${chapterIndex}-${partieIndex}`;
        const newExpanded = new Set(expandedParties);
        if (newExpanded.has(key)) {
            newExpanded.delete(key);
        } else {
            newExpanded.add(key);
        }
        setExpandedParties(newExpanded);
    };

    const handleDeleteVideo = async (chapterIndex, partieIndex, videoId) => {
        try {
            await deleteVideo(id, chapterIndex, partieIndex, videoId);
            fetchCourseData();
            setSelectedVideo(null);
            toast({
                title: "تم الحذف",
                description: "تم حذف الفيديو بنجاح",
                status: "success",
                duration: 3000,
                isClosable: true,
                position: "top-left"
            });
        } catch (error) {
            toast({
                title: "خطأ",
                description: "فشل حذف الفيديو",
                status: "error",
                duration: 3000,
                isClosable: true,
                position: "top-left"
            });
        }
    };

    const openVideoUploadModal = (chapterIndex, partieIndex) => {
        setSelectedChapterIndex(chapterIndex);
        setSelectedPartieIndex(partieIndex);
        setVideoUploadModalOpen(true);
    };

    const fetchRecordings = async () => {
        try {
            setRecordingsLoading(true);
            const res = await axiosInstance.get('/meetings/recordings');
            if (res.data && res.data.success) {
                setRecordings(res.data.data || []);
            }
        } catch (err) {
            console.error('Failed to fetch live recordings:', err);
            toast({
                title: "تعذر تحميل تسجيلات الحصص المباشرة",
                description: err.response?.data?.error || err.message,
                status: "warning",
                duration: 3000,
                isClosable: true
            });
        } finally {
            setRecordingsLoading(false);
        }
    };

    const filteredRecordings = recordings.filter(rec => {
        if (onlyMatchingMatiere && courseData?.name) {
            const courseMat = courseData.name.trim().toLowerCase();
            const recMat = (rec.matiere || '').trim().toLowerCase();
            if (recMat && recMat !== courseMat) {
                return false;
            }
        }
        if (recordingsSearch.trim()) {
            const q = recordingsSearch.trim().toLowerCase();
            const matchName = (rec.roomName || '').toLowerCase().includes(q);
            const matchMat = (rec.matiere || '').toLowerCase().includes(q);
            return matchName || matchMat;
        }
        return true;
    });

    const handleCloseVideoUploadModal = () => {
        setVideoUploadModalOpen(false);
        setNewVideo({
            name: '',
            description: '',
            file: null,
        });
        setUploadSource('file');
        setSelectedRecording(null);
        setLiveSessionUrl('');
        setRecordingsSearch('');
        setUploadProgress(0);
        setIsCalculatingDuration(false);
        setUploadAnimation(false);
    };

    const handleAddVideo = async () => {
        if (selectedChapterIndex === null || selectedPartieIndex === null || !courseData) return;

        // Option 1: Selected from live session recordings (server-side file copy)
        if (uploadSource === 'recording') {
            if (!selectedRecording) {
                toast({
                    title: "تنبيه",
                    description: "يرجى اختيار تسجيل من الحصص المباشرة أولاً",
                    status: "warning",
                    duration: 3000,
                    isClosable: true
                });
                return;
            }

            try {
                setUploadAnimation(true);
                const videoTitle = (newVideo.name || '').trim() || selectedRecording.roomName || 'تسجيل الحصة';
                await axiosInstance.post(`/courses/course/${id}/videos`, {
                    recordingId: selectedRecording._id,
                    nomvideo: videoTitle,
                    description: newVideo.description || `تسجيل حصة مباشرة (${selectedRecording.roomName || ''})`,
                    chapitreIndex: selectedChapterIndex,
                    partieIndex: selectedPartieIndex
                });

                fetchCourseData();
                toast({
                    title: "تمت إضافة التسجيل بنجاح! 🎉",
                    description: `تمت إضافة تسجيل "${videoTitle}" إلى الدورة بنجاح`,
                    status: "success",
                    duration: 4000,
                    isClosable: true,
                    position: "top-left"
                });
                handleCloseVideoUploadModal();
            } catch (error) {
                console.error('Error adding live recording to course:', error);
                toast({
                    title: "خطأ",
                    description: error.response?.data?.message || error.message || "فشل إضافة التسجيل إلى الدورة",
                    status: "error",
                    duration: 4000,
                    isClosable: true,
                    position: "top-left"
                });
            } finally {
                setUploadAnimation(false);
            }
            return;
        }

        // Option 1b: Direct live session URL — no upload, just store the link
        if (uploadSource === 'liveUrl') {
            const url = liveSessionUrl.trim();
            if (!url) {
                toast({
                    title: "تنبيه",
                    description: "يرجى إدخال رابط تسجيل الحصة المباشرة",
                    status: "warning",
                    duration: 3000,
                    isClosable: true
                });
                return;
            }

            try {
                setUploadAnimation(true);
                const videoTitle = (newVideo.name || '').trim() || 'تسجيل حصة مباشرة';
                await axiosInstance.post(`/courses/course/${id}/videos`, {
                    liveUrl: url,
                    nomvideo: videoTitle,
                    description: newVideo.description || '',
                    chapitreIndex: selectedChapterIndex,
                    partieIndex: selectedPartieIndex
                });

                fetchCourseData();
                toast({
                    title: "تمت إضافة الرابط بنجاح! 🎉",
                    description: `تم إضافة "${videoTitle}" بالرابط المباشر`,
                    status: "success",
                    duration: 4000,
                    isClosable: true,
                    position: "top-left"
                });
                handleCloseVideoUploadModal();
            } catch (error) {
                console.error('Error adding live URL to course:', error);
                toast({
                    title: "خطأ",
                    description: error.response?.data?.message || error.message || "فشل إضافة الرابط إلى الدورة",
                    status: "error",
                    duration: 4000,
                    isClosable: true,
                    position: "top-left"
                });
            } finally {
                setUploadAnimation(false);
            }
            return;
        }

        // Option 2: Upload from local file
        if (newVideo.file) {
            try {
                setUploadAnimation(true);
                const formData = new FormData();
                formData.append('video', newVideo.file);
                formData.append('nomvideo', newVideo.name);
                formData.append('description', newVideo.description);
                formData.append('chapitreIndex', selectedChapterIndex);
                formData.append('partieIndex', selectedPartieIndex);

                await axiosInstance.post(`/courses/course/${id}/videos`, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                    onUploadProgress: (progressEvent) => {
                        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                        setUploadProgress(percentCompleted);
                    },
                });

                const needsConversion = !newVideo.file.name.toLowerCase().endsWith('.mp4');
                const uploadedName = newVideo.name;

                fetchCourseData();
                toast({
                    title: "تم الرفع بنجاح!",
                    description: needsConversion
                        ? `تم رفع الفيديو "${uploadedName}"، جاري تحويله إلى MP4...`
                        : `تم رفع الفيديو "${uploadedName}" بنجاح`,
                    status: "success",
                    duration: 4000,
                    isClosable: true,
                    position: "top-left"
                });
                handleCloseVideoUploadModal();

                // If the server converts in the background, wait and refresh
                // once the MP4 (and duration) is ready.
                if (needsConversion) {
                    const converted = await waitForVideoConversion(id);
                    fetchCourseData();
                    if (converted) {
                        toast({
                            title: "تم التحويل بنجاح",
                            description: "تم تحويل الفيديو إلى MP4",
                            status: "success",
                            duration: 4000,
                            isClosable: true,
                            position: "top-left"
                        });
                    }
                }
            } catch (error) {
                setUploadAnimation(false);
                toast({
                    title: "خطأ في الرفع",
                    description: "فشل رفع الفيديو، يرجى المحاولة مرة أخرى",
                    status: "error",
                    duration: 4000,
                    isClosable: true,
                    position: "top-left"
                });
            }
        }
    };

    const handleDeletePartie = async (chapterIndex, partieIndex) => {
        try {
            const courseId = courseData._id;
            const chapitreId = courseData.chapitres[chapterIndex]._id;
            const partieId = courseData.chapitres[chapterIndex].parties[partieIndex]._id;

            await axiosInstance.delete(`courses/courses/${courseId}/chapters/${chapitreId}/parties/${partieId}`);

            const updatedCourseData = { ...courseData };
            updatedCourseData.chapitres[chapterIndex].parties.splice(partieIndex, 1);
            setCourseData(updatedCourseData);

            toast({
                title: "تم الحذف",
                description: "تم حذف الجزء بنجاح",
                status: "success",
                duration: 3000,
                isClosable: true,
                position: "top-left"
            });
        } catch (error) {
            toast({
                title: "خطأ",
                description: "فشل حذف الجزء",
                status: "error",
                duration: 3000,
                isClosable: true,
                position: "top-left"
            });
        }
    };

    const saveAttachmentsToPartie = async (chapterIndex, partieIndex, attachment) => {
        try {
            if (!attachment) {
                toast({
                    title: "خطأ",
                    description: "لم يتم توفير مرفق",
                    status: "error",
                    duration: 3000,
                    isClosable: true,
                    position: "top-left"
                });
                return;
            }

            const formData = new FormData();
            formData.append('file', attachment);
            formData.append('nom', AttchmentName);

            const course = courseData;
            if (!course) {
                toast({
                    title: "خطأ",
                    description: "لم يتم العثور على الدورة",
                    status: "error",
                    duration: 3000,
                    isClosable: true,
                    position: "top-left"
                });
                return;
            }

            const chapitreId = course.chapitres[chapterIndex]?._id;
            const partieId = course.chapitres[chapterIndex]?.parties[partieIndex]?._id;

            if (!chapitreId || !partieId) {
                toast({
                    title: "خطأ",
                    description: "لم يتم العثور على معرف ال محور أو الجزء",
                    status: "error",
                    duration: 3000,
                    isClosable: true,
                    position: "top-left"
                });
                return;
            }

            await axiosInstance.post(
                `/courses/attachment/${id}/chapters/${chapitreId}/parties/${partieId}/add`,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                }
            );

            setAttachmentModalOpen(false);
            fetchCourseData();

            toast({
                title: "تم الرفع",
                description: "تم رفع المرفق بنجاح",
                status: "success",
                duration: 3000,
                isClosable: true,
                position: "top-left"
            });
        } catch (error) {
            toast({
                title: "خطأ",
                description: "فشل رفع المرفق",
                status: "error",
                duration: 3000,
                isClosable: true,
                position: "top-left"
            });
        }
    };

    const toggleChapterState = async (chapterId) => {
        try {
            await toggleChaptire(id, chapterId);
            fetchCourseData();
        } catch (error) {
            toast({
                title: "خطأ",
                description: "فشل تغيير حالة ال محور",
                status: "error",
                duration: 3000,
                isClosable: true,
                position: "top-left"
            });
        }
    };

    const handleDeleteAttachment = async (partieIndex, attIndex, chapIndex) => {
        try {
            const chapitreId = courseData.chapitres[chapIndex]._id;
            const partieId = courseData.chapitres[chapIndex].parties[partieIndex]._id;
            const attachmentId = courseData.chapitres[chapIndex].parties[partieIndex].attachments[attIndex]._id;

            await axiosInstance.delete(
                `/courses/attachment/${id}/chapters/${chapitreId}/parties/${partieId}/attachments/${attachmentId}`
            );

            const updatedParties = [...courseData.chapitres[chapIndex].parties];
            updatedParties[partieIndex].attachments.splice(attIndex, 1);

            setCourseData(prevData => {
                const updatedChapters = [...prevData.chapitres];
                updatedChapters[chapIndex].parties = updatedParties;
                return { ...prevData, chapitres: updatedChapters };
            });

            toast({
                title: "تم الحذف",
                description: "تم حذف المرفق بنجاح",
                status: "success",
                duration: 3000,
                isClosable: true,
                position: "top-left"
            });
        } catch (error) {
            toast({
                title: "خطأ",
                description: "فشل حذف المرفق",
                status: "error",
                duration: 3000,
                isClosable: true,
                position: "top-left"
            });
        }
    };

    const openNewPartieModal = (chapterId) => {
        setChaterID(chapterId);
        setisAddNewPartieOpen(true);
    };

    const handleReorderVideos = async (chapterIndex, partieIndex, videoIndex, direction) => {
        try {
            const updatedVideos = [...courseData.chapitres[chapterIndex].parties[partieIndex].videos];
            const temp = updatedVideos[videoIndex];

            if (direction === 'up' && videoIndex > 0) {
                updatedVideos[videoIndex] = updatedVideos[videoIndex - 1];
                updatedVideos[videoIndex - 1] = temp;
            } else if (direction === 'down' && videoIndex < updatedVideos.length - 1) {
                updatedVideos[videoIndex] = updatedVideos[videoIndex + 1];
                updatedVideos[videoIndex + 1] = temp;
            }

            await axiosInstance.put(
                `courses/updatedVideos/${id}/chapters/${chapterIndex}/parties/${partieIndex}/reorder-videos`,
                { videos: updatedVideos }
            );

            fetchCourseData();
        } catch (error) {
            toast({
                title: "خطأ",
                description: "فشل إعادة ترتيب الفيديوهات",
                status: "error",
                duration: 3000,
                isClosable: true,
                position: "top-left"
            });
        }
    };

    if (!courseData) {
        return (
            <Flex
                justify="center"
                align="center"
                h="100vh"
                bg={bgColor}
            >
                <VStack spacing={4}>
                    <CobraSpinner
                        size="xl"
                        color={accentColor}
                        thickness="4px"
                    />
                    <Text color={textColor} fontSize="lg">جاري تحميل بيانات الدورة...</Text>
                </VStack>
            </Flex>
        );
    }

    return (
        <>
            <Container
                maxW="full"
                p={0}
                transition="margin 0.3s ease"
            >
                <Flex flex="1" direction="column" overflowY="auto">
                    {isMobile && (
                        <Box p={4} bg={cardBg} borderBottom="1px solid" borderColor={borderColor}>
                            <HStack justify="space-between">
                                <IconButton
                                    icon={<HamburgerIcon />}
                                    variant="ghost"
                                    onClick={() => { }} // No sidebar toggle in this version
                                    aria-label="Open menu"
                                />
                                <Text fontSize="lg" fontWeight="bold" color={accentColor}>
                                    تحرير الدورة
                                </Text>
                            </HStack>
                        </Box>
                    )}

                    <Box p={containerPadding}>
                        <Card mb={cardSpacing} bg={cardBg} borderRadius="2xl" border="1px solid" borderColor={borderColor}>
                            <CardHeader bg={sectionHeaderBg} color={textColor} py={6}>
                                <VStack align="start" spacing={4}>
                                    <HStack spacing={4}>
                                        <Box
                                            p={2}
                                            bg={bgColor}
                                            borderRadius="md"
                                        >
                                            <FaGraduationCap size={28} color={accentColor} />
                                        </Box>
                                        <VStack align="start" spacing={1}>
                                            <Heading
                                                size={headerSize}
                                                textAlign="right"
                                                fontWeight="bold"
                                                color={textColor}
                                            >
                                                الدورة: {courseData.name}
                                            </Heading>
                                            <Badge
                                                bg={accentBg}
                                                color={accentColor}
                                                fontSize={isMobile ? "sm" : "md"}
                                                px={3}
                                                py={1}
                                                borderRadius="full"
                                            >
                                            </Badge>
                                        </VStack>
                                    </HStack>
                                    <Button
                                        size={buttonSize}
                                        colorScheme="purple"
                                        leftIcon={<FiMessageSquare />}
                                        onClick={openBulkSmsModal}
                                        borderRadius="md"
                                        shadow="sm"
                                        mt={4}
                                    >
                                        إرسال SMS مجمعة للمقصرين
                                    </Button>
                                </VStack>
                            </CardHeader>
                        </Card>

                        <Stack
                            direction={{ base: "column", lg: "row" }}
                            spacing={cardSpacing}
                            align="stretch"
                        >
                            {/* Chapters List */}
                            <Box
                                flex="1"
                                maxW={{ base: "100%", lg: "45%" }}
                                order={{ base: 1, lg: 1 }}
                            >
                                <Card bg={cardBg} borderRadius="2xl" border="1px solid" borderColor={borderColor}>
                                    <CardHeader bg={sectionHeaderBg} color={textColor} py={5}>
                                        <Stack
                                            direction={{ base: "column", md: "row" }}
                                            justify="space-between"
                                            align={{ base: "stretch", md: "center" }}
                                            spacing={4}
                                        >
                                            <HStack spacing={3}>
                                                <Box
                                                    p={2}
                                                    bg={bgColor}
                                                    borderRadius="md"
                                                >
                                                    <FaBookOpen size={20} color={accentColor} />
                                                </Box>
                                                <Text
                                                    fontSize={{ base: "lg", md: "xl", lg: "2xl" }}
                                                    fontWeight="bold"
                                                    color={textColor}
                                                >
                                                    قائمة المحاور
                                                </Text>
                                            </HStack>
                                            <Button
                                                rightIcon={<AddIcon />}
                                                size={buttonSize}
                                                colorScheme="gray"
                                                color={accentColor}
                                                onClick={onOpen}
                                                borderRadius="md"
                                                px={6}
                                                w={{ base: "full", md: "auto" }}
                                                border="1px solid"
                                                borderColor={borderColor}
                                                bg="white"
                                                _hover={{
                                                    bg: sectionHeaderHoverBg,
                                                    color: accentColor
                                                }}
                                                transition="all 0.2s"
                                            >
                                                إضافة محور جديد
                                            </Button>
                                        </Stack>
                                    </CardHeader>

                                    <CardBody p={0}>
                                        <VStack spacing={0} align="stretch">
                                            {courseData.chapitres.map((chapter, chapterIndex) => (
                                                <Box key={chapter._id}>
                                                    {/* Chapter Header */}
                                                    <Box
                                                        bg={sectionHeaderBg}
                                                        color={textColor}
                                                        p={{ base: 5, md: 6 }}
                                                        cursor="pointer"
                                                        onClick={() => toggleChapter(chapterIndex)}
                                                        _hover={{
                                                            bg: sectionHeaderHoverBg
                                                        }}
                                                        borderBottom="1px solid"
                                                        borderColor={borderColor}
                                                        transition="all 0.2s"
                                                    >
                                                        <Stack
                                                            direction={{ base: "column", md: "row" }}
                                                            justify="space-between"
                                                            w="full"
                                                            spacing={4}
                                                            position="relative"
                                                            zIndex={1}
                                                        >
                                                            <HStack
                                                                spacing={4}
                                                                justify={{ base: "center", md: "flex-start" }}
                                                                flexWrap="wrap"
                                                            >
                                                                <Box
                                                                    transform={expandedChapters.has(chapterIndex) ? "rotate(90deg)" : "rotate(0deg)"}
                                                                    transition="transform 0.2s"
                                                                >
                                                                    <FaChevronRight size={18} color={accentColor} />
                                                                </Box>
                                                                <Tooltip
                                                                    label={!chapter.isOpen ? "محور مقفل" : "محور مفتوح"}
                                                                    placement="top"
                                                                >
                                                                    <IconButton
                                                                        icon={!chapter.isOpen ? <FiLock /> : <FiUnlock />}
                                                                        size="sm"
                                                                        bg="white"
                                                                        color={!chapter.isOpen ? lockRed : lockGreen}
                                                                        border="1px solid"
                                                                        borderColor={!chapter.isOpen ? lockRed : lockGreen}
                                                                        aria-label="Toggle lock"
                                                                        onClick={(e) => {
                                                                            e.stopPropagation();
                                                                            toggleChapterState(chapter._id);
                                                                        }}
                                                                        borderRadius="full"
                                                                        _hover={{
                                                                            bg: chapter.isOpen ? lockRed : lockGreen,
                                                                            color: "white"
                                                                        }}
                                                                        transition="all 0.2s"
                                                                    />
                                                                </Tooltip>
                                                                <Badge
                                                                    bg="white"
                                                                    color={accentColor}
                                                                    borderRadius="full"
                                                                    px={3}
                                                                    py={1}
                                                                    border="1px solid"
                                                                    borderColor={borderColor}
                                                                >
                                                                    {chapter.parties?.length || 0} جزء
                                                                </Badge>
                                                            </HStack>
                                                            <VStack
                                                                align={{ base: "center", md: "end" }}
                                                                spacing={1}
                                                            >
                                                                <Text
                                                                    fontWeight="bold"
                                                                    fontSize={{ base: "lg", md: "xl" }}
                                                                    textAlign={{ base: "center", md: "right" }}
                                                                    color={textColor}
                                                                >
                                                                    {chapter.nom}
                                                                </Text>
                                                                <Text
                                                                    fontSize="sm"
                                                                    opacity={0.8}
                                                                    textAlign={{ base: "center", md: "right" }}
                                                                    noOfLines={2}
                                                                    color={textColor}
                                                                >
                                                                    {chapter.description}
                                                                </Text>
                                                            </VStack>
                                                        </Stack>
                                                    </Box>

                                                    {/* Chapter Content */}
                                                    <Collapse in={expandedChapters.has(chapterIndex)} animateOpacity>
                                                        <Box bg={partieHeaderBg} p={0}>
                                                            <VStack spacing={0} align="stretch">
                                                                {chapter.parties?.map((partie, partieIndex) => (
                                                                    <SlideFade
                                                                        key={partie._id}
                                                                        in={expandedChapters.has(chapterIndex)}
                                                                        offsetY="20px"
                                                                        delay={partieIndex * 0.05}
                                                                    >
                                                                        <Box m={3}>
                                                                            {/* Partie Header */}
                                                                            <Box
                                                                                bg={partieHeaderBg}
                                                                                color={textColor}
                                                                                p={{ base: 3, md: 4 }}
                                                                                borderRadius="md"
                                                                                cursor="pointer"
                                                                                onClick={() => togglePartie(chapterIndex, partieIndex)}
                                                                                _hover={{
                                                                                    bg: partieHeaderHoverBg
                                                                                }}
                                                                                border="1px solid"
                                                                                borderColor={borderColor}
                                                                                transition="all 0.2s"
                                                                            >
                                                                                <Stack
                                                                                    direction="row"
                                                                                    justify="space-between"
                                                                                    spacing={2}
                                                                                    position="relative"
                                                                                    zIndex={1}
                                                                                    flexWrap="wrap"
                                                                                    align="center"
                                                                                >
                                                                                    <HStack
                                                                                        spacing={2}
                                                                                        flexWrap="wrap"
                                                                                        justify="flex-start"
                                                                                    >
                                                                                        <Box
                                                                                            transform={expandedParties.has(`${chapterIndex}-${partieIndex}`) ? "rotate(90deg)" : "rotate(0deg)"}
                                                                                            transition="transform 0.2s"
                                                                                        >
                                                                                            <FaChevronRight size={14} color={accentColor} />
                                                                                        </Box>
                                                                                        <Tooltip label="حذف الجزء">
                                                                                            <IconButton
                                                                                                icon={<DeleteIcon />}
                                                                                                size="sm"
                                                                                                bg="white"
                                                                                                color={lockRed}
                                                                                                border="1px solid"
                                                                                                borderColor={lockRed}
                                                                                                onClick={(e) => {
                                                                                                    e.stopPropagation();
                                                                                                    handleDeletePartie(chapterIndex, partieIndex);
                                                                                                }}
                                                                                                borderRadius="full"
                                                                                                _hover={{
                                                                                                    bg: lockRed,
                                                                                                    color: "white"
                                                                                                }}
                                                                                                transition="all 0.2s"
                                                                                            />
                                                                                        </Tooltip>
                                                                                        <Tooltip label="إضافة مرفق">
                                                                                            <IconButton
                                                                                                icon={<FaPaperclip />}
                                                                                                size="sm"
                                                                                                bg="white"
                                                                                                color={accentColor}
                                                                                                border="1px solid"
                                                                                                borderColor={accentColor}
                                                                                                onClick={(e) => {
                                                                                                    e.stopPropagation();
                                                                                                    setSelectedChapterIndex(chapterIndex);
                                                                                                    setSelectedPartieIndex(partieIndex);
                                                                                                    setAttachmentModalOpen(true);
                                                                                                }}
                                                                                                borderRadius="full"
                                                                                                _hover={{
                                                                                                    bg: accentColor,
                                                                                                    color: "white"
                                                                                                }}
                                                                                                transition="all 0.2s"
                                                                                            />
                                                                                        </Tooltip>
                                                                                        <Tooltip label="إضافة فيديو">
                                                                                            <IconButton
                                                                                                icon={<FaVideo />}
                                                                                                size="sm"
                                                                                                bg="white"
                                                                                                color={lockGreen}
                                                                                                border="1px solid"
                                                                                                borderColor={lockGreen}
                                                                                                onClick={(e) => {
                                                                                                    e.stopPropagation();
                                                                                                    openVideoUploadModal(chapterIndex, partieIndex);
                                                                                                }}
                                                                                                borderRadius="full"
                                                                                                _hover={{
                                                                                                    bg: lockGreen,
                                                                                                    color: "white"
                                                                                                }}
                                                                                                transition="all 0.2s"
                                                                                            />
                                                                                        </Tooltip>
                                                                                        <Badge
                                                                                            bg="white"
                                                                                            color={accentColor}
                                                                                            borderRadius="full"
                                                                                            px={2}
                                                                                            py={0.5}
                                                                                            border="1px solid"
                                                                                            borderColor={borderColor}
                                                                                        >
                                                                                            {(() => {
                                                                                                const numV = partie.videos?.length || 0;
                                                                                                const numA = partie.attachments?.length || 0;
                                                                                                if (numV > 0 && numA > 0) return `${numV} فيديو • ${numA} ${numA === 1 ? 'مرفق' : 'مرفقات'}`;
                                                                                                if (numV > 0) return `${numV} فيديو`;
                                                                                                if (numA > 0) return `${numA} ${numA === 1 ? 'مرفق' : 'مرفقات'}`;
                                                                                                return '0 عنصر';
                                                                                            })()}
                                                                                        </Badge>
                                                                                    </HStack>
                                                                                    <VStack
                                                                                        align={{ base: "flex-end", md: "end" }}
                                                                                        spacing={0}
                                                                                        flex="1"
                                                                                        minW={0}
                                                                                    >
                                                                                        <Text
                                                                                            fontWeight="semibold"
                                                                                            fontSize={{ base: "md", md: "lg" }}
                                                                                            textAlign={{ base: "center", md: "right" }}
                                                                                            color={textColor}
                                                                                        >
                                                                                            {partie.name}
                                                                                        </Text>
                                                                                        <Text
                                                                                            fontSize="sm"
                                                                                            opacity={0.8}
                                                                                            textAlign={{ base: "center", md: "right" }}
                                                                                            noOfLines={2}
                                                                                            color={textColor}
                                                                                        >
                                                                                            {partie.description}
                                                                                        </Text>
                                                                                    </VStack>
                                                                                </Stack>
                                                                            </Box>

                                                                            {/* Partie Content */}
                                                                            <Collapse in={expandedParties.has(`${chapterIndex}-${partieIndex}`)} animateOpacity>
                                                                                <Box
                                                                                    bg="white"
                                                                                    borderRadius="md"
                                                                                    mt={2}
                                                                                    p={4}
                                                                                    border="1px solid"
                                                                                    borderColor={borderColor}
                                                                                >
                                                                                    {/* Videos List */}
                                                                                    <VStack spacing={3} align="stretch">
                                                                                        {partie.videos?.map((video, videoIndex) => (
                                                                                            <ScaleFade
                                                                                                key={video._id}
                                                                                                in={expandedParties.has(`${chapterIndex}-${partieIndex}`)}
                                                                                                delay={videoIndex * 0.05}
                                                                                            >
                                                                                                <Card
                                                                                                    variant="outline"
                                                                                                    size="sm"
                                                                                                    cursor="pointer"
                                                                                                    onClick={() => handleVideoSelect(video)}
                                                                                                    bg={selectedVideo?._id === video._id ? accentBg : "white"}
                                                                                                    borderColor={selectedVideo?._id === video._id ? accentColor : borderColor}
                                                                                                    borderWidth="2px"
                                                                                                    borderRadius="md"
                                                                                                    _hover={{
                                                                                                        bg: accentBg,
                                                                                                        borderColor: accentColor
                                                                                                    }}
                                                                                                    transition="all 0.2s"
                                                                                                >
                                                                                                    <CardBody p={3}>
                                                                                                        <Stack
                                                                                                            direction={{ base: "column", sm: "row" }}
                                                                                                            justify="space-between"
                                                                                                            align={{ base: "stretch", sm: "center" }}
                                                                                                            spacing={2}
                                                                                                        >
                                                                                                            <HStack
                                                                                                                spacing={1}
                                                                                                                justify={{ base: "center", sm: "flex-start" }}
                                                                                                                flexWrap="wrap"
                                                                                                            >
                                                                                                                <Tooltip label="حذف الفيديو">
                                                                                                                    <IconButton
                                                                                                                        icon={<FaTrash />}
                                                                                                                        size="xs"
                                                                                                                        bg="white"
                                                                                                                        color={lockRed}
                                                                                                                        border="1px solid"
                                                                                                                        borderColor={lockRed}
                                                                                                                        variant="ghost"
                                                                                                                        onClick={(e) => {
                                                                                                                            e.stopPropagation();
                                                                                                                            handleDeleteVideo(chapterIndex, partieIndex, video._id);
                                                                                                                        }}
                                                                                                                        borderRadius="full"
                                                                                                                        _hover={{
                                                                                                                            bg: lockRed,
                                                                                                                            color: "white"
                                                                                                                        }}
                                                                                                                    />
                                                                                                                </Tooltip>
                                                                                                                <Tooltip label="تحريك لأعلى">
                                                                                                                    <IconButton
                                                                                                                        icon={<FaArrowUp />}
                                                                                                                        size="xs"
                                                                                                                        variant="ghost"
                                                                                                                        bg="white"
                                                                                                                        color={accentColor}
                                                                                                                        border="1px solid"
                                                                                                                        borderColor={accentColor}
                                                                                                                        onClick={(e) => {
                                                                                                                            e.stopPropagation();
                                                                                                                            handleReorderVideos(chapterIndex, partieIndex, videoIndex, 'up');
                                                                                                                        }}
                                                                                                                        isDisabled={videoIndex === 0}
                                                                                                                        borderRadius="full"
                                                                                                                        _hover={{
                                                                                                                            bg: accentColor,
                                                                                                                            color: "white"
                                                                                                                        }}
                                                                                                                    />
                                                                                                                </Tooltip>
                                                                                                                <Tooltip label="تحريك لأسفل">
                                                                                                                    <IconButton
                                                                                                                        icon={<FaArrowDown />}
                                                                                                                        size="xs"
                                                                                                                        variant="ghost"
                                                                                                                        bg="white"
                                                                                                                        color={accentColor}
                                                                                                                        border="1px solid"
                                                                                                                        borderColor={accentColor}
                                                                                                                        onClick={(e) => {
                                                                                                                            e.stopPropagation();
                                                                                                                            handleReorderVideos(chapterIndex, partieIndex, videoIndex, 'down');
                                                                                                                        }}
                                                                                                                        isDisabled={videoIndex === partie.videos.length - 1}
                                                                                                                        borderRadius="full"
                                                                                                                        _hover={{
                                                                                                                            bg: accentColor,
                                                                                                                            color: "white"
                                                                                                                        }}
                                                                                                                    />
                                                                                                                </Tooltip>
                                                                                                                <Badge
                                                                                                                    colorScheme="gray"
                                                                                                                    size="sm"
                                                                                                                    borderRadius="full"
                                                                                                                    px={2}
                                                                                                                    py={0.5}
                                                                                                                    color={accentColor}
                                                                                                                    bg="white"
                                                                                                                    border="1px solid"
                                                                                                                    borderColor={borderColor}
                                                                                                                >
                                                                                                                    {video.duree}
                                                                                                                </Badge>
                                                                                                            </HStack>
                                                                                                            <VStack
                                                                                                                align={{ base: "center", sm: "end" }}
                                                                                                                spacing={0}
                                                                                                            >
                                                                                                                <Text
                                                                                                                    fontWeight="medium"
                                                                                                                    fontSize="sm"
                                                                                                                    color={accentColor}
                                                                                                                    textAlign={{ base: "center", sm: "right" }}
                                                                                                                >
                                                                                                                    {video.nomvideo}
                                                                                                                </Text>
                                                                                                                <Text
                                                                                                                    fontSize="xs"
                                                                                                                    color={textColor}
                                                                                                                    opacity={0.7}
                                                                                                                    textAlign={{ base: "center", sm: "right" }}
                                                                                                                    noOfLines={2}
                                                                                                                >
                                                                                                                    {video.description}
                                                                                                                </Text>
                                                                                                            </VStack>
                                                                                                        </Stack>
                                                                                                    </CardBody>
                                                                                                </Card>
                                                                                            </ScaleFade>
                                                                                        ))}
                                                                                    </VStack>

                                                                                    {/* Attachments Section */}
                                                                                    {partie.attachments?.length > 0 && (
                                                                                        <Box mt={4}>
                                                                                            <Divider mb={3} />
                                                                                            <Text
                                                                                                fontSize="sm"
                                                                                                fontWeight="semibold"
                                                                                                color={accentColor}
                                                                                                mb={2}
                                                                                            >
                                                                                                المرفقات:
                                                                                            </Text>
                                                                                            <VStack spacing={2} align="stretch">
                                                                                                {partie.attachments.map((attachment, attIndex) => (
                                                                                                    <HStack
                                                                                                        onClick={() => window.open(urlvideo + attachment.url)}
                                                                                                        key={attIndex}
                                                                                                        justify="space-between"
                                                                                                        p={2}
                                                                                                        bg="gray.50"
                                                                                                        borderRadius="md"
                                                                                                        cursor="pointer"
                                                                                                        border="1px solid"
                                                                                                        borderColor={borderColor}
                                                                                                        _hover={{
                                                                                                            bg: "gray.100"
                                                                                                        }}
                                                                                                        transition="all 0.2s"
                                                                                                    >
                                                                                                        <IconButton
                                                                                                            icon={<FaTrash />}
                                                                                                            size="xs"
                                                                                                            bg="white"
                                                                                                            color={lockRed}
                                                                                                            border="1px solid"
                                                                                                            borderColor={lockRed}
                                                                                                            variant="ghost"
                                                                                                            onClick={() => handleDeleteAttachment(partieIndex, attIndex, chapterIndex)}
                                                                                                            borderRadius="full"
                                                                                                            _hover={{
                                                                                                                bg: lockRed,
                                                                                                                color: "white"
                                                                                                            }}
                                                                                                        />
                                                                                                        <Text fontSize="sm" textAlign="right" fontWeight="medium" color={textColor} flex="1" noOfLines={1} minW={0}>
                                                                                                            {attachment.nom}
                                                                                                        </Text>
                                                                                                    </HStack>
                                                                                                ))}
                                                                                            </VStack>
                                                                                        </Box>
                                                                                    )}
                                                                                </Box>
                                                                            </Collapse>
                                                                        </Box>
                                                                    </SlideFade>
                                                                ))}

                                                                {/* Add New Partie Button */}
                                                                <Box p={4}>
                                                                    <Button
                                                                        leftIcon={<AddIcon />}
                                                                        onClick={() => openNewPartieModal(chapter._id)}
                                                                        variant="outline"
                                                                        colorScheme="gray"
                                                                        size={buttonSize}
                                                                        w="full"
                                                                        borderRadius="md"
                                                                        borderWidth="1px"
                                                                        borderColor={borderColor}
                                                                        _hover={{
                                                                            bg: sectionHeaderHoverBg,
                                                                            color: accentColor
                                                                        }}
                                                                        transition="all 0.2s"
                                                                    >
                                                                        إضافة جزء جديد
                                                                    </Button>
                                                                </Box>
                                                            </VStack>
                                                        </Box>
                                                    </Collapse>
                                                </Box>
                                            ))}
                                        </VStack>
                                    </CardBody>
                                </Card>
                            </Box>

                            {/* Video Player Section */}
                            <Box
                                flex="1"
                                maxW={{ base: "100%", lg: "55%" }}
                                order={{ base: 2, lg: 2 }}
                            >
                                <Card bg={cardBg} borderRadius="2xl" border="1px solid" borderColor={borderColor}>
                                    <CardHeader bg={sectionHeaderBg} color={textColor} py={5}>
                                        <Stack
                                            direction={{ base: "column", md: "row" }}
                                            justify="space-between"
                                            align={{ base: "center", md: "center" }}
                                            spacing={4}
                                        >
                                            <HStack spacing={3}>
                                                <Box
                                                    p={2}
                                                    bg={bgColor}
                                                    borderRadius="md"
                                                >
                                                    <FaPlay size={20} color={accentColor} />
                                                </Box>
                                                <Badge
                                                    bg={accentBg}
                                                    color={accentColor}
                                                    fontSize={{ base: "sm", md: "md" }}
                                                    px={3}
                                                    py={1}
                                                    borderRadius="full"
                                                    border="1px solid"
                                                    borderColor={borderColor}
                                                >
                                                    مشغل الفيديو
                                                </Badge>
                                            </HStack>
                                            <Text
                                                fontSize={{ base: "lg", md: "xl" }}
                                                fontWeight="bold"
                                                color={textColor}
                                            >
                                                عرض المحتوى
                                            </Text>
                                        </Stack>
                                    </CardHeader>

                                    <CardBody p={{ base: 4, md: 6 }}>
                                        {selectedVideo ? (
                                            <VStack spacing={5} align="stretch">
                                                <Card variant="outline" borderRadius="md" borderWidth="1.5px" borderColor={borderColor}>
                                                    <CardBody p={0}>
                                                        <VideoPlayer
                                                            idvdocipher={selectedVideo.idvdocipher}
                                                            videoId={selectedVideo.idvdocipher}
                                                            video={selectedVideo}
                                                        />
                                                    </CardBody>
                                                </Card>

                                                <VStack align="start" spacing={3}>
                                                    <Heading
                                                        size={{ base: "md", md: "lg" }}
                                                        color={accentColor}
                                                        textAlign="right"
                                                    >
                                                        {selectedVideo.nomvideo}
                                                    </Heading>

                                                    <Stack
                                                        direction={{ base: "column", sm: "row" }}
                                                        spacing={3}
                                                        w="full"
                                                    >
                                                        <Badge
                                                            colorScheme="gray"
                                                            fontSize="sm"
                                                            px={3}
                                                            py={1}
                                                            borderRadius="full"
                                                            color={accentColor}
                                                            bg="white"
                                                            border="1px solid"
                                                            borderColor={borderColor}
                                                        >
                                                            <FaClock style={{ marginLeft: 4 }} />
                                                            المدة: {selectedVideo.duree}
                                                        </Badge>
                                                        <Badge
                                                            colorScheme="gray"
                                                            fontSize="sm"
                                                            px={3}
                                                            py={1}
                                                            borderRadius="full"
                                                            color={accentColor}
                                                            bg="white"
                                                            border="1px solid"
                                                            borderColor={borderColor}
                                                        >
                                                            <FaEye style={{ marginLeft: 4 }} />
                                                            جاري العرض
                                                        </Badge>
                                                    </Stack>

                                                    <Box
                                                        p={4}
                                                        bg="gray.50"
                                                        borderRadius="md"
                                                        w="full"
                                                        border="1px solid"
                                                        borderColor={borderColor}
                                                    >
                                                        <Text
                                                            color={textColor}
                                                            lineHeight="tall"
                                                            textAlign="right"
                                                            fontSize={{ base: "sm", md: "md" }}
                                                        >
                                                            {selectedVideo.description}
                                                        </Text>
                                                    </Box>

                                                    {/* ===== Homework Replies Panel ===== */}
                                                    <Box
                                                        mt={2}
                                                        p={5}
                                                        bg={partieHeaderBg}
                                                        borderRadius="xl"
                                                        border="1px solid"
                                                        borderColor={borderColor}
                                                        w="full"
                                                    >
                                                        <HStack justify="space-between" mb={4} flexWrap="wrap" spacing={3}>
                                                            <HStack spacing={2}>
                                                                <Text fontSize="lg">📋</Text>
                                                                <Heading size="sm" fontWeight="700" color={accentColor}>
                                                                    ردود الواجب المنزلي
                                                                </Heading>
                                                                <Badge colorScheme="blue" borderRadius="full" px={2} fontSize="xs">
                                                                    {allHomeworkReplies.length} طالب
                                                                </Badge>
                                                            </HStack>
                                                            <HStack spacing={2}>
                                                                <Button
                                                                    size="xs"
                                                                    variant="outline"
                                                                    colorScheme="blue"
                                                                    borderRadius="full"
                                                                    onClick={() => fetchHomeworkReplies(selectedVideo)}
                                                                    isLoading={isLoadingHomework}
                                                                >
                                                                    تحديث
                                                                </Button>
                                                                <Menu>
                                                                    <MenuButton
                                                                        as={Button}
                                                                        size="xs"
                                                                        bgGradient="linear(to-r, orange.400, red.400)"
                                                                        color="white"
                                                                        borderRadius="full"
                                                                        fontWeight="700"
                                                                        rightIcon={<FiChevronDown />}
                                                                        _hover={{ bgGradient: 'linear(to-r, orange.500, red.500)' }}
                                                                        _active={{ bgGradient: 'linear(to-r, orange.500, red.500)' }}
                                                                    >
                                                                        📱 إرسال SMS
                                                                    </MenuButton>
                                                                    <Portal>
                                                                        <MenuList zIndex={2000} shadow="xl" borderRadius="lg" border="1px solid" borderColor="gray.100">
                                                                            <MenuItem 
                                                                                icon={<span>💬</span>}
                                                                                fontWeight="600"
                                                                                onClick={() => openSmsModal('absent')}
                                                                            >
                                                                                تذكير المتغيبين
                                                                            </MenuItem>
                                                                            <MenuItem 
                                                                                icon={<span>✨</span>}
                                                                                fontWeight="600"
                                                                                onClick={() => openSmsModal('present')}
                                                                            >
                                                                                 إرسال رسالة شكر
                                                                            </MenuItem>
                                                                        </MenuList>
                                                                    </Portal>
                                                                </Menu>
                                                            </HStack>
                                                        </HStack>

                                                        {isLoadingHomework ? (
                                                            <Center py={6}><CobraSpinner color={accentColor} /></Center>
                                                        ) : allHomeworkReplies.length === 0 ? (
                                                            <Center py={5}>
                                                                <VStack spacing={1}>
                                                                    <Text fontSize="xl">🖼️</Text>
                                                                    <Text color="gray.600" fontSize="sm">لا توجد ردود بعد</Text>
                                                                </VStack>
                                                            </Center>
                                                        ) : (
                                                            <VStack align="stretch" spacing={4}>
                                                                {allHomeworkReplies.map((reply) => (
                                                                    <Box
                                                                        key={reply._id}
                                                                        p={4}
                                                                        bg={cardBg}
                                                                        borderRadius="lg"
                                                                        border="1px solid"
                                                                        borderColor={borderColor}
                                                                        boxShadow="sm"
                                                                    >
                                                                        <HStack mb={3} spacing={3}>
                                                                            <Avatar size="sm" name={reply.studentId?.username} />
                                                                            <VStack align="flex-start" spacing={0}>
                                                                                <Text fontWeight="700" fontSize="sm" color={textColor}>
                                                                                    {reply.studentId?.username}
                                                                                </Text>
                                                                                <Text fontSize="xs" color="gray.500">
                                                                                    {new Date(reply.submittedAt).toLocaleString('ar-EG')}
                                                                                </Text>
                                                                            </VStack>
                                                                            <Badge colorScheme="green" borderRadius="full" px={2} mr="auto" fontSize="xs">
                                                                                ✅ أرسل
                                                                            </Badge>
                                                                        </HStack>
                                                                        <SimpleGrid columns={{ base: 2, md: 3 }} spacing={2}>
                                                                            {reply.photoUrls.map((url, i) => (
                                                                                <Image
                                                                                    key={i}
                                                                                    src={`https://api.cobra-education.com${url.startsWith('/') ? '' : '/'}${url}`}
                                                                                    borderRadius="lg"
                                                                                    objectFit="cover"
                                                                                    h="90px"
                                                                                    w="100%"
                                                                                    cursor="pointer"
                                                                                    onClick={() => window.open(`https://api.cobra-education.com${url.startsWith('/') ? '' : '/'}${url}`, '_blank')}
                                                                                    boxShadow="sm"
                                                                                    _hover={{ transform: 'scale(1.03)', transition: 'all 0.2s' }}
                                                                                    alt={`واجب ${reply.studentId?.username}`}
                                                                                />
                                                                            ))}
                                                                        </SimpleGrid>

                                                                        {/* Remarque Section */}
                                                                        <Box mt={4} p={3} bg="gray.50" _dark={{ bg: 'gray.700' }} borderRadius="md" borderLeft="4px solid" borderColor="blue.400">
                                                                            {editingRemarkId === reply._id ? (
                                                                                <VStack align="stretch" spacing={2}>
                                                                                    <Textarea
                                                                                        size="sm"
                                                                                        value={remarkText}
                                                                                        onChange={(e) => setRemarkText(e.target.value)}
                                                                                        placeholder="اكتب ملاحظة للتلميذ..."
                                                                                        bg="white"
                                                                                        _dark={{ bg: 'gray.800' }}
                                                                                    />
                                                                                    <HStack justify="flex-end">
                                                                                        <Button size="xs" variant="ghost" onClick={() => { setEditingRemarkId(null); setRemarkText(''); }}>إلغاء</Button>
                                                                                        <Button size="xs" colorScheme="blue" isLoading={isSavingRemark} onClick={() => handleSaveRemark(reply._id)}>حفظ</Button>
                                                                                    </HStack>
                                                                                </VStack>
                                                                            ) : (
                                                                                <VStack align="stretch" spacing={2}>
                                                                                    {reply.remarque ? (
                                                                                        <Text fontSize="sm" color="gray.700" _dark={{ color: 'gray.200' }}>
                                                                                            <Text as="span" fontWeight="bold" color="blue.500" mr={1}>ملاحظة الأستاذ:</Text>
                                                                                            {reply.remarque}
                                                                                        </Text>
                                                                                    ) : (
                                                                                        <Text fontSize="sm" color="gray.600" fontStyle="italic">بدون ملاحظة</Text>
                                                                                    )}
                                                                                    <Button alignSelf="flex-start" size="xs" variant="link" colorScheme="blue" onClick={() => { setEditingRemarkId(reply._id); setRemarkText(reply.remarque || ''); }}>
                                                                                        {reply.remarque ? 'تعديل الملاحظة' : 'إضافة ملاحظة'}
                                                                                    </Button>
                                                                                </VStack>
                                                                            )}
                                                                        </Box>
                                                                    </Box>
                                                                ))}
                                                            </VStack>
                                                        )}
                                                    </Box>
                                                </VStack>
                                            </VStack>
                                        ) : (
                                            <VStack
                                                spacing={3}
                                                align="center"
                                                justify="center"
                                                h={{ base: "150px", md: "350px" }}
                                                color={textColor}
                                            >
                                                <Box
                                                    p={{ base: 3, md: 6 }}
                                                    bg="gray.50"
                                                    borderRadius="full"
                                                    opacity={0.5}
                                                    display={{ base: "none", md: "block" }}
                                                >
                                                    <FaVideo size={56} />
                                                </Box>
                                                <VStack spacing={1}>
                                                    <Text
                                                        fontSize={{ base: "md", md: "xl" }}
                                                        fontWeight="semibold"
                                                    >
                                                        لم يتم اختيار فيديو
                                                    </Text>
                                                    <Text
                                                        opacity={0.7}
                                                        textAlign="center"
                                                        fontSize={{ base: "xs", md: "md" }}
                                                        px={2}
                                                    >
                                                        اختر فيديو من قائمة المحاور أدناه لبدء المشاهدة
                                                    </Text>
                                                </VStack>
                                            </VStack>
                                        )}
                                    </CardBody>
                                </Card>
                            </Box>
                        </Stack>
                    </Box>
                </Flex>
            </Container>

            {/* ===== SMS Reminder Modal ===== */}
            <Modal isOpen={isSmsModalOpen} onClose={() => setIsSmsModalOpen(false)} isCentered size="md" dir="rtl">
                <ModalOverlay backdropFilter="blur(8px)" />
                <ModalContent borderRadius="2xl" fontFamily="Tajawal, sans-serif" dir="rtl" mx={isMobile ? 4 : 0}>
                    <ModalHeader
                        bgGradient={smsType === 'present' ? "linear(to-r, green.400, teal.400)" : "linear(to-r, orange.400, red.400)"}
                        color="white"
                        borderTopRadius="2xl"
                        textAlign="right"
                        fontWeight="700"
                        py={4}
                        px={6}
                    >
                        {smsType === 'present' ? '📱 إرسال رسالة شكر (للحاضرين)' : '📱 إرسال رسالة SMS إلى الغائبين'}
                    </ModalHeader>
                    <ModalCloseButton color="white" top={3} left={3} right="auto" />
                    <ModalBody py={5} px={6}>
                        <VStack spacing={4} align="stretch">
                            <Text color="gray.600" fontSize="sm" textAlign="right">
                                سيتم إرسال رسالة عربية للطلاب الذين لم يرسلوا واجباتهم عن الفيديو:
                            </Text>
                            <Box p={3} bg="orange.50" borderRadius="lg" border="1px solid" borderColor="orange.200">
                                <Text fontWeight="700" color="orange.700" textAlign="right" fontSize="sm">
                                    🎬 {selectedVideo?.nomvideo}
                                </Text>
                            </Box>

                            <FormControl mt={2}>
                                <HStack justify="space-between" mb={2} flexWrap="wrap">
                                    <FormLabel fontSize="sm" fontWeight="bold" m={0}>نص الرسالة:</FormLabel>
                                    <HStack spacing={2}>
                                        <Button
                                            size="xs"
                                            colorScheme="blue"
                                            variant="outline"
                                            onClick={() => setCustomMessage(prev => prev + ' {studentName}')}
                                        >
                                            إدراج اسم الطالب
                                        </Button>
                                        <Button
                                            size="xs"
                                            colorScheme="purple"
                                            variant="outline"
                                            onClick={() => setCustomMessage(prev => prev + ' {videoName}')}
                                        >
                                            إدراج اسم الفيديو
                                        </Button>
                                    </HStack>
                                </HStack>
                                <Textarea
                                    value={customMessage}
                                    onChange={(e) => setCustomMessage(e.target.value)}
                                    placeholder="مرحباً... يرجى العلم بأن الواجب الخاص بـ..."
                                    rows={5}
                                    fontSize="md"
                                    bg="white"
                                    _dark={{ bg: 'gray.800' }}
                                    border="2px solid"
                                    borderColor="blue.300"
                                    borderRadius="xl"
                                    boxShadow="sm"
                                    focusBorderColor="blue.500"
                                    p={3}
                                />
                            </FormControl>

                            <Text color="gray.500" fontSize="xs" textAlign="right" mt={2}>
                                اختر الجهة للتنفيذ:
                            </Text>
                        </VStack>
                    </ModalBody>
                    <ModalFooter gap={3} justifyContent="center" pb={5}>
                        <Button
                            bgGradient="linear(to-r, blue.400, purple.400)"
                            color="white"
                            borderRadius="full"
                            fontWeight="700"
                            size="md"
                            px={6}
                            isLoading={isSendingSms}
                            loadingText="جاري..."
                            onClick={() => handleSendSms('students')}
                            _hover={{ bgGradient: 'linear(to-r, blue.500, purple.500)', transform: 'translateY(-2px)' }}
                            transition="all 0.2s"
                        >
                            👨‍🎓 إرسال للطلاب
                        </Button>
                        <Button
                            bgGradient="linear(to-r, green.400, teal.400)"
                            color="white"
                            borderRadius="full"
                            fontWeight="700"
                            size="md"
                            px={6}
                            isLoading={isSendingSms}
                            loadingText="جاري..."
                            onClick={() => handleSendSms('parents')}
                            _hover={{ bgGradient: 'linear(to-r, green.500, teal.500)', transform: 'translateY(-2px)' }}
                            transition="all 0.2s"
                        >
                            👨‍👩‍👦 إرسال لأولياء الأمور
                        </Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>

            {/* Video Upload Modal */}
            <Modal
                isOpen={videoUploadModalOpen}
                onClose={handleCloseVideoUploadModal}
                size={modalSize}
                isCentered
                closeOnOverlayClick={!uploadAnimation}
            >
                <ModalOverlay backdropFilter="blur(10px)" />
                <ModalContent
                    borderRadius="2xl"
                    overflow="hidden"
                    mx={isMobile ? 4 : 0}
                    border="1px solid"
                    borderColor={borderColor}
                >
                    <ModalHeader
                        bg={sectionHeaderBg}
                        color={textColor}
                        textAlign="center"
                        py={6}
                    >
                        <VStack spacing={2}>
                            <Box p={3} bg={bgColor} borderRadius="md">
                                {uploadSource === 'recording' ? (
                                    <MdCloudDone size={28} color={accentColor} />
                                ) : uploadSource === 'liveUrl' ? (
                                    <FaPlay size={28} color="#38B2AC" />
                                ) : (
                                    <FaVideo size={28} color={accentColor} />
                                )}
                            </Box>
                            <Text fontSize={{ base: "lg", md: "xl" }} fontWeight="bold">
                                {uploadAnimation
                                    ? (uploadSource === 'recording' ? "جاري ربط التسجيل بالدورة..."
                                       : uploadSource === 'liveUrl' ? "جاري حفظ الرابط..."
                                       : "جاري رفع الفيديو...")
                                    : (uploadSource === 'recording' ? "إضافة فيديو من تسجيلات الحصص المباشرة"
                                       : uploadSource === 'liveUrl' ? "إضافة فيديو برابط مباشر"
                                       : "رفع فيديو جديد")}
                            </Text>
                            <Text fontSize="sm" opacity={0.8}>
                                {uploadAnimation
                                    ? "يرجى الانتظار حتى اكتمال العملية"
                                    : (uploadSource === 'recording' ? "اختر التسجيل المطلوب لإضافته فوراً كفيديو للمادة"
                                       : uploadSource === 'liveUrl' ? "الصق رابط تسجيل الحصة مباشرةً — لن يتم إعادة رفع أي ملف"
                                       : "اختر ملف فيديو وسيتم حساب المدة تلقائياً")}
                            </Text>
                        </VStack>
                    </ModalHeader>
                    <ModalCloseButton color={textColor} isDisabled={uploadAnimation} />

                    <ModalBody p={{ base: 6, md: 8 }}>
                        <VStack spacing={6}>
                            {/* Source Switcher: 3 tabs */}
                            <HStack spacing={2} p={1} bg={sectionHeaderBg} borderRadius="xl" w="full" flexWrap="wrap">
                                <Button
                                    flex={1}
                                    size="sm"
                                    variant={uploadSource === 'file' ? 'solid' : 'ghost'}
                                    colorScheme={uploadSource === 'file' ? 'blue' : 'gray'}
                                    leftIcon={<FaVideo />}
                                    onClick={() => {
                                        setUploadSource('file');
                                        setSelectedRecording(null);
                                        setLiveSessionUrl('');
                                    }}
                                    borderRadius="lg"
                                    isDisabled={uploadAnimation}
                                >
                                    رفع من الجهاز
                                </Button>
                                <Button
                                    flex={1}
                                    size="sm"
                                    variant={uploadSource === 'recording' ? 'solid' : 'ghost'}
                                    colorScheme={uploadSource === 'recording' ? 'blue' : 'gray'}
                                    leftIcon={<MdCloudDone />}
                                    onClick={() => {
                                        setUploadSource('recording');
                                        setNewVideo(prev => ({ ...prev, file: null }));
                                        setLiveSessionUrl('');
                                        if (recordings.length === 0) {
                                            fetchRecordings();
                                        }
                                    }}
                                    borderRadius="lg"
                                    isDisabled={uploadAnimation}
                                >
                                    من تسجيلات الحصص
                                </Button>
                                <Button
                                    flex={1}
                                    size="sm"
                                    variant={uploadSource === 'liveUrl' ? 'solid' : 'ghost'}
                                    colorScheme={uploadSource === 'liveUrl' ? 'teal' : 'gray'}
                                    leftIcon={<FaPlay />}
                                    onClick={() => {
                                        setUploadSource('liveUrl');
                                        setSelectedRecording(null);
                                        setNewVideo(prev => ({ ...prev, file: null }));
                                    }}
                                    borderRadius="lg"
                                    isDisabled={uploadAnimation}
                                >
                                    رابط مباشر
                                </Button>
                            </HStack>

                            <FormControl>
                                <FormLabel color={textColor} fontWeight="bold" fontSize="md">
                                    اسم الفيديو
                                </FormLabel>
                                <Input
                                    value={newVideo.name}
                                    onChange={(e) => setNewVideo({ ...newVideo, name: e.target.value })}
                                    placeholder={uploadSource === 'recording' ? "أدخل اسم الفيديو (أو اختر تسجيلاً ليتم ملؤه تلقائياً)" : "أدخل اسم الفيديو"}
                                    borderRadius="md"
                                    borderWidth="1.5px"
                                    borderColor={borderColor}
                                    bg="gray.50"
                                    py={4}
                                    fontSize="md"
                                    isDisabled={uploadAnimation}
                                />
                            </FormControl>

                            <FormControl>
                                <FormLabel color={textColor} fontWeight="bold" fontSize="md">
                                    وصف الفيديو
                                </FormLabel>
                                <Textarea
                                    value={newVideo.description}
                                    onChange={(e) => setNewVideo({ ...newVideo, description: e.target.value })}
                                    placeholder="أدخل وصف للفيديو"
                                    borderRadius="md"
                                    borderWidth="1.5px"
                                    borderColor={borderColor}
                                    bg="gray.50"
                                    py={3}
                                    fontSize="md"
                                    rows={3}
                                    resize="vertical"
                                    isDisabled={uploadAnimation}
                                />
                            </FormControl>

                            {/* Option 1: Live Session Recordings Selection */}
                            {uploadSource === 'recording' && (
                                <FormControl w="full">
                                    <Flex justify="space-between" align="center" mb={2}>
                                        <FormLabel color={textColor} fontWeight="bold" fontSize="md" mb={0}>
                                            اختر تسجيل الحصة المباشرة
                                        </FormLabel>
                                        {courseData?.name && (
                                            <Checkbox
                                                isChecked={onlyMatchingMatiere}
                                                onChange={(e) => setOnlyMatchingMatiere(e.target.checked)}
                                                size="sm"
                                                colorScheme="blue"
                                            >
                                                مادة {courseData.name} فقط
                                            </Checkbox>
                                        )}
                                    </Flex>

                                    <Input
                                        value={recordingsSearch}
                                        onChange={(e) => setRecordingsSearch(e.target.value)}
                                        placeholder="ابحث باسم الحصة المباشرة أو المادة..."
                                        size="sm"
                                        borderRadius="md"
                                        mb={3}
                                        bg="gray.50"
                                        isDisabled={uploadAnimation}
                                    />

                                    {recordingsLoading ? (
                                        <Center py={8}>
                                            <VStack spacing={2}>
                                                <CobraSpinner />
                                                <Text fontSize="sm" color="gray.500">جاري جلب تسجيلات الحصص المباشرة...</Text>
                                            </VStack>
                                        </Center>
                                    ) : (
                                        <Box maxH="220px" overflowY="auto" pr={1} w="full">
                                            {filteredRecordings.length === 0 ? (
                                                <Center p={6} bg="gray.50" borderRadius="md" border="1px dashed" borderColor={borderColor}>
                                                    <VStack spacing={1}>
                                                        <Text fontSize="sm" color="gray.500">لا توجد تسجيلات مطابقة</Text>
                                                        {onlyMatchingMatiere && (
                                                            <Button size="xs" variant="link" colorScheme="blue" onClick={() => setOnlyMatchingMatiere(false)}>
                                                                عرض كل التسجيلات
                                                            </Button>
                                                        )}
                                                    </VStack>
                                                </Center>
                                            ) : (
                                                <VStack spacing={2} align="stretch">
                                                    {filteredRecordings.map((rec) => {
                                                        const isSelected = selectedRecording?._id === rec._id;
                                                        return (
                                                            <Box
                                                                key={rec._id}
                                                                p={3}
                                                                borderRadius="lg"
                                                                borderWidth="2px"
                                                                borderColor={isSelected ? "blue.500" : borderColor}
                                                                bg={isSelected ? "blue.50" : "white"}
                                                                cursor={uploadAnimation ? "not-allowed" : "pointer"}
                                                                onClick={() => {
                                                                    if (uploadAnimation) return;
                                                                    setSelectedRecording(rec);
                                                                    if (!newVideo.name || newVideo.name === selectedRecording?.roomName) {
                                                                        setNewVideo(prev => ({ ...prev, name: rec.roomName }));
                                                                    }
                                                                }}
                                                                transition="all 0.15s"
                                                                _hover={{ borderColor: "blue.400", bg: isSelected ? "blue.50" : "gray.50" }}
                                                            >
                                                                <Flex justify="space-between" align="center">
                                                                    <HStack spacing={3}>
                                                                        <Box color={isSelected ? "blue.600" : "gray.400"}>
                                                                            {isSelected ? <MdCheckCircle size={22} /> : <MdCloudDone size={22} />}
                                                                        </Box>
                                                                        <VStack align="start" spacing={0}>
                                                                            <Text fontWeight="bold" fontSize="sm" color={textColor}>
                                                                                {rec.roomName || "تسجيل حصة"}
                                                                            </Text>
                                                                            <HStack spacing={2} fontSize="xs" color="gray.500">
                                                                                {rec.matiere && <Badge colorScheme="purple" fontSize="10px">{rec.matiere}</Badge>}
                                                                                <Text>{rec.createdAt ? new Date(rec.createdAt).toLocaleDateString('ar-TN') : ''}</Text>
                                                                                {rec.recordingDuration ? (
                                                                                    <Text>• {Math.floor(rec.recordingDuration / 60)} د</Text>
                                                                                ) : null}
                                                                                {rec.recordingSize ? (
                                                                                    <Text>• {(rec.recordingSize / (1024 * 1024)).toFixed(1)} MB</Text>
                                                                                ) : null}
                                                                            </HStack>
                                                                        </VStack>
                                                                    </HStack>
                                                                    <Badge colorScheme={isSelected ? "blue" : "gray"} variant={isSelected ? "solid" : "subtle"}>
                                                                        {isSelected ? "تم الاختيار ✓" : "اختيار"}
                                                                    </Badge>
                                                                </Flex>
                                                            </Box>
                                                        );
                                                    })}
                                                </VStack>
                                            )}
                                        </Box>
                                    )}
                                </FormControl>
                            )}

                            {/* Option 2: Upload File From Device */}
                            {uploadSource === 'file' && (
                                <FormControl>
                                    <FormLabel color={textColor} fontWeight="bold" fontSize="md">
                                        ملف الفيديو
                                    </FormLabel>
                                    <Box
                                        position="relative"
                                        borderRadius="md"
                                        borderWidth="2px"
                                        borderStyle="dashed"
                                        borderColor={newVideo.file ? lockGreen : borderColor}
                                        bg={newVideo.file ? "green.50" : "gray.50"}
                                        p={6}
                                        textAlign="center"
                                        cursor={uploadAnimation ? "not-allowed" : "pointer"}
                                        _hover={{
                                            borderColor: uploadAnimation ? borderColor : accentColor,
                                            bg: uploadAnimation ? "gray.50" : accentBg
                                        }}
                                        transition="all 0.2s"
                                        onClick={() => !uploadAnimation && document.getElementById('video-file-input').click()}
                                    >
                                        <Input
                                            id="video-file-input"
                                            type="file"
                                            accept="video/*"
                                            onChange={(e) => handleVideoFileChange(e.target.files[0])}
                                            position="absolute"
                                            opacity={0}
                                            w="full"
                                            h="full"
                                            cursor="pointer"
                                            isDisabled={uploadAnimation}
                                        />
                                        <VStack spacing={2}>
                                            <Box
                                                p={3}
                                                bg={newVideo.file ? "green.100" : "gray.200"}
                                                borderRadius="md"
                                                color={newVideo.file ? lockGreen : "gray.600"}
                                            >
                                                <FaVideo size={24} />
                                            </Box>
                                            <Text fontSize="md" fontWeight="bold" color={newVideo.file ? lockGreen : textColor}>
                                                {newVideo.file ? "تم اختيار الملف ✓" : "اختر ملف الفيديو"}
                                            </Text>
                                            <Text fontSize="sm" color="gray.600" textAlign="center">
                                                {newVideo.file
                                                    ? `${newVideo.file.name} (${(newVideo.file.size / (1024 * 1024)).toFixed(2)} MB)`
                                                    : "اسحب الملف هنا أو انقر للاختيار"
                                                }
                                            </Text>
                                        </VStack>
                                    </Box>
                                </FormControl>
                            )}

                            {/* Option 3: Direct live session URL */}
                            {uploadSource === 'liveUrl' && (
                                <FormControl w="full">
                                    <FormLabel color={textColor} fontWeight="bold" fontSize="md">
                                        رابط تسجيل الحصة المباشرة
                                    </FormLabel>
                                    <Input
                                        value={liveSessionUrl}
                                        onChange={(e) => setLiveSessionUrl(e.target.value)}
                                        placeholder="الصق رابط الفيديو هنا (مثلاً: https://...)"
                                        borderRadius="md"
                                        borderWidth="1.5px"
                                        borderColor={liveSessionUrl ? 'teal.400' : borderColor}
                                        bg="gray.50"
                                        py={4}
                                        fontSize="md"
                                        dir="ltr"
                                        isDisabled={uploadAnimation}
                                    />
                                    {liveSessionUrl && (
                                        <Text fontSize="xs" color="teal.600" mt={1}>
                                            ✓ سيتم حفظ هذا الرابط مباشرةً دون إعادة رفع الملف
                                        </Text>
                                    )}
                                </FormControl>
                            )}

                            {uploadSource === 'file' && (uploadProgress > 0 || uploadAnimation) && (
                                <Box w="full">
                                    <VStack spacing={3}>
                                        <HStack justify="space-between" w="full">
                                            <Text fontWeight="bold" color={textColor} fontSize="md">
                                                {uploadProgress === 100 ? "تم الرفع بنجاح!" : `جاري الرفع: ${uploadProgress}%`}
                                            </Text>
                                            <Badge
                                                colorScheme={uploadProgress === 100 ? "green" : "blue"}
                                                fontSize="md"
                                                px={3}
                                                py={1}
                                                borderRadius="md"
                                            >
                                                {uploadProgress}%
                                            </Badge>
                                        </HStack>
                                        <Box w="full" position="relative">
                                            <Progress
                                                value={uploadProgress}
                                                colorScheme={uploadProgress === 100 ? "green" : "blue"}
                                                borderRadius="md"
                                                size="lg"
                                                bg="gray.200"
                                                hasStripe={uploadProgress < 100}
                                                isAnimated={uploadProgress < 100}
                                            />
                                            {uploadProgress === 100 && (
                                                <Box
                                                    position="absolute"
                                                    top="50%"
                                                    left="50%"
                                                    transform="translate(-50%, -50%)"
                                                    color="white"
                                                    fontWeight="bold"
                                                    fontSize="sm"
                                                >
                                                    مكتمل ✓
                                                </Box>
                                            )}
                                        </Box>
                                        {uploadAnimation && uploadProgress < 100 && (
                                            <Text fontSize="sm" color={accentColor} textAlign="center">
                                                يرجى عدم إغلاق النافذة أثناء الرفع...
                                            </Text>
                                        )}
                                    </VStack>
                                </Box>
                            )}
                        </VStack>
                    </ModalBody>

                    <ModalFooter p={{ base: 6, md: 8 }} pt={0}>
                        <Stack direction={{ base: "column", sm: "row" }} spacing={3} w="full">
                            <Button
                                variant="outline"
                                onClick={handleCloseVideoUploadModal}
                                borderRadius="md"
                                borderWidth="1.5px"
                                px={6}
                                py={4}
                                fontSize="md"
                                w={{ base: "full", sm: "auto" }}
                                isDisabled={uploadAnimation}
                                _hover={{ bg: sectionHeaderHoverBg }}
                                transition="all 0.2s"
                            >
                                إلغاء
                            </Button>
                            <Button
                                colorScheme={uploadSource === 'liveUrl' ? 'teal' : 'blue'}
                                color="white"
                                onClick={handleAddVideo}
                                isDisabled={
                                    uploadAnimation ||
                                    !newVideo.name ||
                                    (uploadSource === 'file'
                                        ? (!newVideo.file || isCalculatingDuration)
                                        : uploadSource === 'recording'
                                            ? !selectedRecording
                                            : !liveSessionUrl.trim()
                                    )
                                }
                                isLoading={uploadAnimation}
                                loadingText={
                                    uploadSource === 'recording' ? "جاري ربط التسجيل..."
                                    : uploadSource === 'liveUrl' ? "جاري الحفظ..."
                                    : "جاري الرفع..."
                                }
                                borderRadius="md"
                                px={6}
                                py={4}
                                fontSize="md"
                                fontWeight="bold"
                                w={{ base: "full", sm: "auto" }}
                                _hover={{ opacity: 0.9 }}
                                transition="all 0.2s"
                                rightIcon={!uploadAnimation ? (
                                    uploadSource === 'recording' ? <MdCloudDone />
                                    : uploadSource === 'liveUrl' ? <FaPlay />
                                    : <FaVideo />
                                ) : undefined}
                            >
                                {uploadSource === 'recording' ? "إضافة التسجيل للدورة"
                                 : uploadSource === 'liveUrl' ? "حفظ الرابط المباشر"
                                 : "رفع الفيديو"}
                            </Button>
                        </Stack>
                    </ModalFooter>
                </ModalContent>
            </Modal>
            {/* Attachment Upload Modal */}
            <Modal
                isOpen={attachmentModalOpen}
                onClose={() => setAttachmentModalOpen(false)}
                size={modalSize}
                isCentered
            >
                <ModalOverlay backdropFilter="blur(10px)" />
                <ModalContent borderRadius="2xl" overflow="hidden" mx={isMobile ? 4 : 0} border="1px solid" borderColor={borderColor}>
                    <ModalHeader
                        bg={sectionHeaderBg}
                        color={textColor}
                        textAlign="center"
                        py={5}
                    >
                        <VStack spacing={2}>
                            <Box
                                p={2}
                                bg={bgColor}
                                borderRadius="md"
                            >
                                <FaPaperclip size={22} color={accentColor} />
                            </Box>
                            <Text fontSize={{ base: "lg", md: "xl" }} fontWeight="bold">إضافة مرفق</Text>
                        </VStack>
                    </ModalHeader>
                    <ModalCloseButton color={textColor} />

                    <ModalBody p={{ base: 4, md: 8 }}>
                        <VStack spacing={5}>
                            <FormControl>
                                <FormLabel color={textColor} fontWeight="semibold">اسم المرفق</FormLabel>
                                <Input
                                    value={AttchmentName}
                                    onChange={(e) => setAttchmentName(e.target.value)}
                                    placeholder="أدخل اسم المرفق"
                                    borderRadius="md"
                                    borderWidth="1.5px"
                                    borderColor={borderColor}
                                />
                            </FormControl>

                            <FormControl>
                                <FormLabel color={textColor} fontWeight="semibold">ملف المرفق</FormLabel>
                                <Input
                                    type="file"
                                    onChange={(e) => setAttachments(e.target.files[0])}
                                    borderRadius="md"
                                    borderWidth="1.5px"
                                    borderColor={borderColor}
                                    p={2}
                                />
                            </FormControl>
                        </VStack>
                    </ModalBody>

                    <ModalFooter p={{ base: 4, md: 8 }} pt={0}>
                        <Stack
                            direction={{ base: "column", sm: "row" }}
                            spacing={3}
                            w="full"
                        >
                            <Button
                                variant="outline"
                                onClick={() => setAttachmentModalOpen(false)}
                                borderRadius="md"
                                borderWidth="1.5px"
                                px={6}
                                w={{ base: "full", sm: "auto" }}
                                _hover={{
                                    bg: sectionHeaderHoverBg
                                }}
                            >
                                إلغاء
                            </Button>
                            <Button
                                colorScheme="blue"
                                color="white"
                                onClick={() => saveAttachmentsToPartie(selectedChapterIndex, selectedPartieIndex, attachments)}
                                isDisabled={!attachments || !AttchmentName}
                                borderRadius="md"
                                px={6}
                                w={{ base: "full", sm: "auto" }}
                                _hover={{
                                    bg: accentColor
                                }}
                                transition="all 0.2s"
                            >
                                رفع المرفق
                            </Button>
                        </Stack>
                    </ModalFooter>
                </ModalContent>
            </Modal>

            {/* New Chapter Modal */}
            <NewChapterToCourse
                isOpen={isOpen}
                onClose={onClose}
                courseId={id}
                onChapterAdded={fetchCourseData}
            />

            {/* New Partie Modal */}
            <AddPartieForm
                isOpen={isAddNewPartieOpen}
                onClose={() => setisAddNewPartieOpen(false)}
                courseId={id}
                chapterId={ChaterID}
                onPartieAdded={fetchCourseData}
            />

            {/* Bulk SMS Modal */}
            <Modal isOpen={isBulkSmsModalOpen} onClose={() => setIsBulkSmsModalOpen(false)} isCentered dir="rtl" size="xl">
                <ModalOverlay backdropFilter="blur(5px)" bg="blackAlpha.600" />
                <ModalContent borderRadius="2xl" overflow="hidden">
                    <ModalHeader bgGradient="linear(to-r, purple.500, blue.500)" color="white" pt={4} pb={4} fontWeight="700">
                        إرسال SMS مجمعة للغائبين
                    </ModalHeader>
                    <ModalCloseButton color="white" top={3} left={3} right="auto" />
                    <ModalBody py={6} maxH="60vh" overflowY="auto" css={{ '&::-webkit-scrollbar': { width: '8px' }, '&::-webkit-scrollbar-thumb': { background: '#CBD5E0', borderRadius: '4px' } }}>
                        <VStack align="stretch" spacing={6}>
                            <Box>
                                <Text fontWeight="bold" mb={3} color="purple.600">حدد الفيديوهات المعنية بالواجب:</Text>
                                <Box p={4} bg={bgColor} borderRadius="xl" border="1px solid" borderColor={borderColor}>
                                    <CheckboxGroup colorScheme="purple" value={selectedVideosForSms} onChange={setSelectedVideosForSms}>
                                        <VStack align="start" spacing={4} w="full">
                                            {courseData?.chapitres?.map((ch, idx) => (
                                                <Box key={ch._id} w="full" bg={cardBg} p={3} borderRadius="lg" borderWidth="1px" borderColor={borderColor}>
                                                    <Text fontWeight="bold" color={accentColor} mb={2}>{ch.name || ch.nom || `محور ${idx + 1}`}</Text>
                                                    <VStack align="start" spacing={2} pl={4}>
                                                        {ch.parties?.map((p, pIdx) => (
                                                            <Box key={p._id} w="full">
                                                                {(p.name || p.nompartie) && <Text fontSize="sm" fontWeight="semibold" color="gray.600" _dark={{ color: "gray.400" }} mb={1}>{p.name || p.nompartie}</Text>}
                                                                <VStack align="start" spacing={1} pl={4}>
                                                                    {p.videos?.map(v => (
                                                                        <Checkbox key={v._id} value={v._id}>
                                                                            <Text fontSize="sm">{v.title || v.nomvideo}</Text>
                                                                        </Checkbox>
                                                                    ))}
                                                                </VStack>
                                                            </Box>
                                                        ))}
                                                    </VStack>
                                                </Box>
                                            ))}
                                        </VStack>
                                    </CheckboxGroup>
                                </Box>
                            </Box>

                            <Box>
                                <Text fontWeight="bold" mb={2} color="purple.600">رسالة مخصصة (اختياري):</Text>
                                <Text fontSize="xs" color="gray.500" mb={2}>
                                    يمكنك استخدام المتغيرات التالية: <br />
                                    <Text as="span" fontWeight="bold" color="blue.500">{"{studentName}"}</Text> لاسم الطالب <br />
                                    <Text as="span" fontWeight="bold" color="blue.500">{"{videoNames}"}</Text> لقائمة الفيديوهات (كل فيديو في سطر) <br />
                                    <Text as="span" fontWeight="bold" color="blue.500">{"{inlineVideoNames}"}</Text> لقائمة الفيديوهات (مفصولة بفاصلة)
                                </Text>
                                <Textarea
                                    value={bulkSmsMessage}
                                    onChange={(e) => setBulkSmsMessage(e.target.value)}
                                    placeholder="اترك هذا الحقل فارغاً لاستخدام الرسالة الافتراضية"
                                    rows={4}
                                    borderRadius="xl"
                                />
                            </Box>

                            <Box>
                                <Text fontWeight="bold" mb={2} color="purple.600">لمن تود الإرسال؟</Text>
                                <HStack spacing={4}>
                                    <Button
                                        flex="1"
                                        variant={bulkSmsTarget === 'parents' ? 'solid' : 'outline'}
                                        colorScheme="blue"
                                        onClick={() => setBulkSmsTarget('parents')}
                                    >
                                        أولياء الأمور
                                    </Button>
                                    <Button
                                        flex="1"
                                        variant={bulkSmsTarget === 'students' ? 'solid' : 'outline'}
                                        colorScheme="blue"
                                        onClick={() => setBulkSmsTarget('students')}
                                    >
                                        الطلاب
                                    </Button>
                                </HStack>
                            </Box>
                        </VStack>
                    </ModalBody>
                    <ModalFooter bg={sectionHeaderBg} borderTop="1px solid" borderColor={borderColor}>
                        <Button variant="ghost" mr={3} onClick={() => setIsBulkSmsModalOpen(false)}>إلغاء</Button>
                        <Button
                            bgGradient="linear(to-r, purple.500, blue.500)"
                            color="white"
                            _hover={{ bgGradient: "linear(to-r, purple.600, blue.600)" }}
                            onClick={handleBulkSmsSubmit}
                            isLoading={isSendingBulkSms}
                            isDisabled={selectedVideosForSms.length === 0}
                        >
                            إرسال SMS الآن
                        </Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>
        </>
    );
};

export default CourseDetailsContent;

